<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div>
          <material-card>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-btn color="general" light class="mb-2" @click="newItem">{{
                    $t("language.new")
                  }}</v-btn>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="grid.search"
                    append-icon="search"
                    :label="$t('language.search')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-dialog v-model="dialog" max-width="600px">
              <ValidationObserver ref="form" v-slot="{ passes }">
                <v-form @submit.prevent="passes(save)">
                  <v-card>
                    <v-card-title>{{ $t("language.leave") }}</v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.name')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.name"
                                :label="$t('language.name')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.shortname')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.shortname"
                                :label="$t('language.shortname')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.gender')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="vModel.gender"
                                :items="genderList"
                                :label="$t('language.gender')"
                                :error-messages="errors[0]"
                                :clearable="true"
                              ></v-autocomplete>
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.days')"
                              rules="required|numeric"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.days"
                                :label="$t('language.days')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.maxaccumulatedays')"
                              rules="numeric"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.maxaccumulatedays"
                                :label="$t('language.maxaccumulatedays')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-switch
                              v-model="vModel.accumulate"
                              :label="$t('language.accumulate')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-switch
                              v-model="vModel.countholiday"
                              :label="$t('language.countholiday')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-switch
                              v-model="vModel.countweekend"
                              :label="$t('language.countweekend')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-switch
                              v-model="vModel.officialperiodapplicable"
                              :label="$t('language.officialperiodapplicable')"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-switch
                              v-model="vModel.checkbalance"
                              :label="$t('language.checkbalance')"
                            ></v-switch>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="grey darken-1" text @click="closedialog">{{
                        $t("language.cancel")
                      }}</v-btn>
                      <v-btn
                        v-if="!isEdit"
                        color="green darken-1"
                        @click="passes(saveandreset)"
                        text
                        type="button"
                        >{{ $t("language.saveandreset") }}</v-btn
                      >
                      <v-btn color="blue darken-1" text type="submit">{{
                        $t("language.save")
                      }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-dialog>

            <v-data-table
              :headers="grid.headers"
              :items="grid.body"
              :search="grid.search"
              :options.sync="grid.options"
              :server-items-length="grid.total"
              :loading="grid.loading"
              :footer-props="grid.footerProps"
              :items-per-page="grid.itemsperpage"
              class="elevation-2"
            >
              <template v-slot:header.name>
                <span>{{ $t("language.name") }}</span>
              </template>
              <template v-slot:header.shortname>
                <span>{{ $t("language.shortname") }}</span>
              </template>
              <template v-slot:header.gender>
                <span>{{ $t("language.gender") }}</span>
              </template>
              <template v-slot:header.days>
                <span>{{ $t("language.days") }}</span>
              </template>
              <template v-slot:header.accumulate>
                <span>{{ $t("language.accumulate") }}</span>
              </template>
              <template v-slot:header.countholiday>
                <span>{{ $t("language.countholiday") }}</span>
              </template>
              <template v-slot:header.countweekend>
                <span>{{ $t("language.countweekend") }}</span>
              </template>
              <template v-slot:item.accumulate="{ item }">
                {{ item.accumulate ? "Yes" : "No" }}
              </template>
              <template v-slot:item.countholiday="{ item }">
                {{ item.countholiday ? "Yes" : "No" }}
              </template>
              <template v-slot:item.countweekend="{ item }">
                {{ item.countweekend ? "Yes" : "No" }}
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item.id)"
                  >edit</v-icon
                >
                <v-icon small @click="deleteItem(item.id)">delete</v-icon>
              </template>
            </v-data-table>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Base from "../../../shared/Base.vue";
import commonservice from "../../../shared/common.service";
export default {
  name: "leaveview",
  extends: Base,
  data() {
    return {
      genderList: commonservice.genderList,
    };
  },
  created() {
    this.grid.headers = [
      { value: "name" },
      { value: "shortname" },
      { value: "gender" },
      { value: "days" },
      { value: "accumulate" },
      { value: "countholiday" },
      { value: "countweekend" },
      { value: "action", sortable: false },
    ];
    this.vModel = {
      id: null,
      shortname: null,
      gender: null,
      days: null,
      accumulate: false,
      countholiday: false,
      countweekend: false,
      maxaccumulatedays: null,
      officialperiodapplicable: false,
      checkbalance: false,
    };
    this.url = "client/setup/leaves";
  },
};
</script>
